export default __webpack_public_path__ + "static/image-tip-calculator-7e4b128d0f01b2027d7dee89e8b4c643.png";